import { useEffect, useState } from 'react';

const mobileQuery = '(max-width: 960px)';

const getMobileMatch = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.matchMedia(mobileQuery).matches;
};

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(getMobileMatch);

  useEffect(() => {
    const mediaQuery = window.matchMedia(mobileQuery);
    const updateMatch = () => {
      setIsMobile(mediaQuery.matches);
    };

    updateMatch();
    mediaQuery.addEventListener('change', updateMatch);

    return () => {
      mediaQuery.removeEventListener('change', updateMatch);
    };
  }, []);

  return isMobile;
};
